import { render, staticRenderFns } from "./PageHeaderComponent.vue?vue&type=template&id=354a4f22"
import script from "./PageHeaderComponent.vue?vue&type=script&lang=js"
export * from "./PageHeaderComponent.vue?vue&type=script&lang=js"
import style0 from "./PageHeaderComponent.vue?vue&type=style&index=0&id=354a4f22&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports